export var socialLinks = {
  facebookUrl: "https://www.facebook.com/simplylifeinsurance/",
  twitterUrl: "https://twitter.com/simply_co_za",
  instagramUrl: "https://www.instagram.com/simply.co.za/",
  youtubeUrl: "https://www.youtube.com/channel/UClJFOx1HIsQlnM9kUPGZ3pA"
};
export var contactDetails = {
  numbers: {
    callcenter: "021 045 1393",
    callcenter27: "+27210451393",
    help: "021 045 1513",
    help27: "+27210451513"
  },
  address: {
    company: "Simply Financial Services",
    building: "Grove Exchange",
    street: "9 Grove Avenue",
    suburb: "Claremont",
    city: "Cape Town",
    postalCode: "7701"
  },
  fsp: "47146"
};
export var urls = {
  packages: {
    family: "/packages/family-cover",
    domestic: "/packages/domestic-cover",
    group: "/packages/group-cover"
  },
  products: {
    life: "/life",
    disability: "/disability",
    funeral: "/funeral"
  },
  claims: "/claims",
  faqs: "/faq",
  brokers: "/simply-brokers",
  resources: "/resources",
  testimonials: "/testimonials",
  press: "/press",
  about: "/about-us",
  aboutOmart: "/omart",
  contact: "/contact",
  getAQuote: "/",
  privacyPolicy: "/privacy-policy",
  terms: "/terms-conditions",
  blog: "/blog",
  omart: "/omart",
  home: "/"
};
export var linkConfig = {
  packages: {
    family: {
      title: "Family cover",
      href: urls.packages.family
    },
    domestic: {
      title: "Domestic cover",
      href: urls.packages.domestic
    },
    group: {
      title: "Staff Cover",
      href: urls.packages.group
    }
  },
  products: {
    life: {
      title: "Life insurance",
      href: urls.products.life
    },
    disability: {
      title: "Disability insurance",
      href: urls.products.disability
    },
    funeral: {
      title: "Funeral insurance",
      href: urls.products.funeral
    }
  },
  claims: {
    title: "How to claim",
    href: urls.claims
  },
  faqs: {
    title: "FAQs",
    href: urls.faqs
  },
  resources: {
    title: "Useful resources",
    href: urls.resources
  },
  testimonials: {
    title: "Testimonials",
    href: urls.testimonials
  },
  press: {
    title: "In the news",
    href: urls.press
  },
  about: {
    title: "About us",
    href: urls.about
  },
  aboutOmart: {
    title: "About OMART",
    href: urls.aboutOmart
  },
  contact: {
    title: "Contact us",
    href: urls.contact
  },
  getAQuote: {
    title: "Get a quote",
    href: urls.getAQuote
  },
  privacyPolicy: {
    title: "Privacy policy",
    href: urls.privacyPolicy
  },
  terms: {
    title: "Terms & conditions",
    href: urls.terms
  },
  blog: {
    title: "Blog",
    href: urls.blog
  },
  omart: {
    title: "About OMART",
    href: urls.omart
  },
  login: {
    title: "Login",
    href: ""
  },
  brokers: {
    title: "For brokers",
    href: urls.brokers
  },
  callcenterNumber: {
    title: contactDetails.numbers.callcenter,
    href: "tel:" + contactDetails.numbers.callcenter27
  },
  helplineNumber: {
    title: contactDetails.numbers.help,
    href: "tel:" + contactDetails.numbers.help27
  }
};
export var linkGroupConfig = {
  whoweare: {
    title: "Who we are",
    links: [linkConfig.about, linkConfig.aboutOmart, linkConfig.testimonials, linkConfig.blog, linkConfig.press]
  },
  products: {
    title: "What we offer",
    links: [linkConfig.packages.family, linkConfig.packages.domestic, linkConfig.packages.group, linkConfig.getAQuote]
  },
  cover: {
    title: "Cover",
    links: [linkConfig.products.life, linkConfig.products.disability, linkConfig.products.funeral]
  },
  help: {
    title: "Help",
    links: [linkConfig.claims, linkConfig.faqs, linkConfig.resources, linkConfig.contact]
  },
  company: {
    title: "Company",
    links: [linkConfig.about, linkConfig.omart, linkConfig.press, linkConfig.testimonials]
  },
  legal: {
    title: "Legal",
    links: [linkConfig.privacyPolicy, linkConfig.terms]
  }
};
export default {
  socialLinks: socialLinks,
  contactDetails: contactDetails,
  urls: urls,
  linkConfig: linkConfig,
  linkGroupConfig: linkGroupConfig
};